import React, { useState } from "react";
import { Chip } from "@mui/material";
import { Event } from "../Events";
import Details from "./Details";
import EventChat from "./EventChat";
import Checklist from "./Checklist";
import Photos from "./Photos";
import Results from "./Results";
import Training from "./Training";
import SlidingSidebar from "../../Components/SlidingSidebar";
import type { TabConfig } from "../../Components/SlidingSidebar";

interface EventDetailsProps {
  open: boolean;
  onClose: () => void;
  eventData: Event | null;
  columns: Array<{
    key: string;
    header: string;
    render?: (value: any, rowData: Event) => React.ReactNode;
  }>;
  eventDetails: Array<{
    key: string;
    header: string;
    render?: (value: any, rowData: Event) => React.ReactNode;
  }>;
  events: Event[];
  inert: boolean;
}

const EventDetails: React.FC<EventDetailsProps> = ({
  open,
  onClose,
  eventData,
  eventDetails,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  if (!eventData) {
    return null;
  }

  // TODO: Uncomment this when ready for production
  // const showResultsTab = eventData.status === "Live" || eventData.status === "Completed";
  const showResultsTab = true; // Temporary: show for all statuses during development
  const isLive = eventData.status === "Live";

  const tabs: TabConfig[] = [
    {
      label: "Details",
      component: (
        <Details
          eventData={eventData}
          columns={eventDetails}
          onClose={onClose}
        />
      ),
    },
    ...(showResultsTab
      ? [
          {
            label: isLive ? (
              <Chip
                label="LIVE"
                sx={{
                  bgcolor: "error.main",
                  color: "white",
                  "& .MuiChip-label": {
                    fontWeight: "bold",
                  },
                }}
              />
            ) : (
              "Results"
            ),
            component: <Results eventData={eventData} />,
          },
        ]
      : []),
    { label: "Training", component: <Training eventData={eventData} /> },
    { label: "Chat", component: <EventChat eventData={eventData} /> },
    { label: "Checklist", component: <Checklist eventData={eventData} /> },
    { label: "Photos", component: <Photos eventData={eventData} /> },
  ];

  return (
    <SlidingSidebar
      open={open}
      onClose={onClose}
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    />
  );
};

export default EventDetails;
